import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

// One partner row already included in an FE scheduling batch (name + email stay paired in DB).
@Entity()
export class PartnerSchedulingRequestedPartner extends AdornisEntity {
  static override _class = 'PartnerSchedulingRequestedPartner';

  static override resolveID(_entity: PartnerSchedulingRequestedPartner): string {
    return (_entity._id ??= A.getGloballyUniqueID());
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(() => String)
  partnerName: Maybe<string>;

  @Field(() => String)
  contactEmail: Maybe<string>;

  @Field(() => String)
  contactName: Maybe<string>;

  @Field(() => String)
  contactPhone: Maybe<string>;
}
